export const state = {
    dataList: [],
  }
  
  export const mutations = {
    SET_DATA_LIST(state, payload) {
      state.dataList = payload
    },
  }
  
  export const actions = {
    setDataList({ commit }, payload) {
      commit('SET_DATA_LIST', payload)
    },
  }
  